$.formUtils.addValidator({
	name: 'notEmptySelection',
	validatorFunction: function (val, $el, config, language, $form) {
		let isValid = true;
		let manager = $el.data('manager');
		if(manager == undefined) {
			console.log(`Not possible to use "notEmptySelection" validator for non-table element`);
		} else {
			let selection = manager.getSelectedIndexes();
			if(selection.length == 0) {
				isValid = false;
			}
		}
		return isValid;
	},
	errorMessage: 'Si deve selezionare almeno un elemento',
	errorMessageKey: 'badSelection'
});
